export default "__VITE_ASSET__BsKDm0UD__"